//this page was initially for managing discounts only
//but now it is for managing discounts and parents a patchy fix :(
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { FiEdit, FiTrash2 } from 'react-icons/fi';
import { userRequest } from '../utils/requestMethods';
import { Header, AddDiscountModal, CustomPagination, SkeletonTable, TabView } from '../components';
import { useStateContext } from '../contexts/ContextProvider';
//import useKYCStatusRedirect from '../hooks/useKYCStatusRedirect';
import { displaySchoolTerm } from '../utils/schoolYearUtils';
import ParentsTable from '../components/ParentsTable';
import AnnouncementModal from '../components/AnnouncementModal';
import { MdPeople, MdLocalOffer, MdNotifications } from 'react-icons/md';

const customStyles = {
  headRow: {
    style: {
      backgroundColor: 'rgb(248, 250, 252)',
      fontWeight: "bold",
    },
  },
};

const Discounts = () => {
  //useKYCStatusRedirect("/discounts");
  const { school } = useStateContext();
  const [discount, setDiscount] = useState();
  const [parents, setParents] = useState([]);
  const [percentage, setPercentage] = useState("");
  const [user, setUser] = useState("");
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const schoolId = school?._id;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('parents');
  const [isAnnouncementModalOpen, setIsAnnouncementModalOpen] = useState(false);

  const tabs = [
    {
      id: 'parents',
      label: 'Parents',
      icon: <MdPeople className="text-xl" />
    },
    /*{
      id: 'discounts',
      label: 'Discounts',
      icon: <MdLocalOffer className="text-xl" />
    }*/
  ];

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const toggleAnnouncementModal = () => {
    setIsAnnouncementModalOpen(!isAnnouncementModalOpen);
  };

  /*useEffect(() => {
    const fetchDiscount = async () => {
      if (schoolId) {
        try {
          setLoading(true);
          const { data } = await userRequest.get(`discount/${schoolId}?sort_by=date&order=des`);
          setDiscount(data.discounts);
          setLoading(false);
        } catch (error) {
          console.log(error);
        } finally {
          setLoading(false);
        }
      }
    };
    fetchDiscount();
  }, [schoolId, refresh]);*/

  useEffect(() => {
    const fetchParents = async () => {
      if (schoolId) {
        try {
          setLoading(true);
          const { data } = await userRequest.get(`schools/${schoolId}/parents`);
          setParents(data.parents || []);
          setLoading(false);
        } catch (error) {
          console.log(error);
        } finally {
          setLoading(false);
        }
      }
    };
    fetchParents();
  }, [schoolId]);

  const submitHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!percentage || !user) {
      setError("Please Fill all the Fields");
      setTimeout(() => {
        setError("");
      }, 2000);
      setLoading(false);
      return;
    }
    try {
      await userRequest.post(`/discount/create/${schoolId}`,
        {
          percentage: percentage,
          user: user,
          term: school.term,
          session: school.session,
        });
      setRefresh(!refresh);
      setSuccess(true);
      setTimeout(() => {
        setSuccess(false);
        setPercentage("");
        setUser("");
        toggleModal();
      }, 2000);
    } catch (error) {
      console.log(error);
      setError(error.response.data);
      setTimeout(() => {
        setError("");
      }, 5000);
      setLoading(false);
    }
    setLoading(false);
  };

  const columns = [
    {
      name: "Discount Percentage",
      selector: row => <span className="font-bold">{row.percentage}%</span>
    },
    {
      name: "Parent",
      selector: row => row?.user?.firstname + " " + row?.user?.lastname
    },
    {
      name: "Term",
      selector: row => <span className="font-bold">{displaySchoolTerm(row?.term)} - {row.session}</span>
    },
    {
      name: "Date",
      selector: row => (new Date(row.createdAt)).toLocaleDateString('en-NG'),
      sortable: true
    },
    {
      cell: (row) => <button style={{ background: 'rgb(139, 231, 139)' }} className="text-white py-1 px-2 capitalize rounded-2xl text-md font-bold">Active</button>,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      cell: (row) => <Link to={`/discounts`} style={{ color: '#1e4db7', backgroundColor: '#91a6f5' }} className="text-md opacity-0.9 rounded-full p-3 hover:drop-shadow-xl"><FiEdit /></Link>,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      cell: (row) => <button style={{ color: 'rgb(228, 106, 118)', backgroundColor: 'rgb(255, 244, 229)' }} className="text-md opacity-0.9 rounded-full p-3 hover:drop-shadow-xl"><FiTrash2 /></button>,
      ignoreRowClick: true,
      button: true,
    },
  ];

  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 dark:bg-secondary-dark-bg bg-white rounded-3xl min-h-screen">
      <div className="flex justify-between items-center mb-6">
        <Header category="Set up" title="Parents Management" />
        <div className="flex gap-4">
          {activeTab === 'parents' && (
            <Link to="/announcements">
              <button 
                type="button" 
                //onClick={toggleAnnouncementModal} 
                className="inline-flex items-center justify-center py-2 px-4 border border-transparent shadow-sm text-md font-medium rounded-full text-white bg-[#3F3DA5] hover:bg-[#2E2D7A] focus:outline-none focus:ring-2 focus:ring-offset-2"
              >
                <MdNotifications className="mr-2" />
                Notify Parents
              </button>
            </Link>
          )}
          {/*activeTab === 'discounts' && (
            <button 
              type="button" 
              onClick={toggleModal} 
              className="inline-flex items-center justify-center py-2 px-4 border border-transparent shadow-sm text-md font-medium rounded-full text-white bg-[#3F3DA5] hover:bg-[#2E2D7A] focus:outline-none focus:ring-2 focus:ring-offset-2"
            >
              Give Discount
            </button>
          )*/}
        </div>
      </div>

      <TabView
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
      />

      <div className="mt-4">
        {activeTab === 'discounts' ? (
          <div className="border rounded-3xl">
            <DataTable
              data={discount}
              columns={columns}
              getRowId={(row) => row._id}
              pagination
              paginationComponentOptions={{
                rowsPerPageText: 'Rows per page:',
                rangeSeparatorText: 'of',
                selectAllRowsItem: true,
                selectAllRowsItemText: 'All',
              }}
              paginationComponent={CustomPagination}
              paginationRowsPerPageOptions={[10, 20, 30, 50]}
              customStyles={customStyles}
              progressPending={loading}
              progressComponent={<SkeletonTable rows={5} columns={6} />}
            />
          </div>
        ) : (
          <ParentsTable />
        )}
      </div>

      {isModalOpen && 
        <AddDiscountModal 
          closeModal={toggleModal}
          parents={parents}
          percentage={percentage}
          setPercentage={setPercentage}
          user={user}
          setUser={setUser}
          error={error}
          success={success}
          loading={loading} 
          submitHandler={submitHandler}
        />
      }

      {isAnnouncementModalOpen && 
        <AnnouncementModal 
          closeModal={toggleAnnouncementModal}
        />
      }
    </div>
  );
};

export default Discounts;
